// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8bc54161","453":"7e95859c","732":"b8a3e0cc"}[chunkId] + ".chunk.js";
};